
/*
  ドロワーメニュー
*/
import {isIE} from '../helper/checkUserBrowser';
let current_scrollTop  = 0;

//navToggleの関数
function navToggle(element) {
  //contains:文字列が引数に指定した文字列を含まれているかどうか[nav-open]
  if (element.classList.contains('nav-open')) {
    //メニュークローズ時
    // cancelFixedBackground(current_scrollTop);
    navCloseFunc(element);
  } else {
    //メニューオープン時
    // 現在のスクロール位置を取得して格納する。(close時に同じ位置に移動させるため)
    current_scrollTop  = isIE() ? document.documentElement.scrollTop : document.scrollingElement.scrollTop;
    // fixedBackground(current_scrollTop);
    navOpenFunc(element);
  }
}

//メニューオープン時の関数
function navOpenFunc(element) {
  //wrapperのclass[nav-open]付与
  
  element.classList.add('nav-open');
}
//メニュークローズ時の関数
function navCloseFunc(element) {
  //wrapperのclass[nav-open]削除
  element.classList.remove('nav-open');
}

function fixedBackground(positionY) {
  // IE かどうかの判定で、利用するプロパティを変える。
  // 背景にposition: fixedを設定すると、一番上の位置で固定されてしまうので、現在のスクロール位置を取得して、それをcssで設定する。
  let elementBody = document.body
  elementBody.style.position = 'fixed'; // fixedするときコメントアウトを取る
  elementBody.style.top = `${-1 * positionY}px`; // fixedするときコメントアウトを取る
  let elementMain = document.getElementsByTagName("main");
  elementMain[0].style.width = "100vw";
}

function cancelFixedBackground(positionY) {
  let elementBody = document.body
  elementBody.style.position = '';
  elementBody.style.top = '';
  let elementMain = document.getElementsByTagName("main");
  elementMain[0].style.width = '';
  // fixed解除時に一番上へと移動してしまうので、open時に取得したスクロール位置まで移動させる。
  window.scrollTo(0, positionY); // fixedするときコメントアウトを取る

}

export function drawerMenu(elementHeader) {
  //ハンバーガーボタンクリック時の関数
  // let el = document.getElementById('navBtn');
  // el.addEventListener('click', () => {
  //   el.classList.toggle('is-active');
  // })
  elementHeader.classList.toggle('is-active');

  //全体を囲む要素をid[#wrapper]で指定
  let elHeader = document.getElementById('jsScrollHeader');
  navToggle(elHeader);
  // //メニューオープン・クローズのボタン要素をid[nav-btn]で指定
  // let elNavBtn = document.getElementById('navBtn');
  // //クリックしたら navToggle関数実行
  // elNavBtn.addEventListener('click', navToggle(elHeader));
}